// extracted by mini-css-extract-plugin
module.exports = {"footer":"styles_footer__1HRIk","content":"styles_content__1eqEt","selectAll":"styles_selectAll__x-XfD"};